import script from "./CookieInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./CookieInfoModal.vue?vue&type=style&index=0&id=45c9a17e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c9a17e"]])

export default __exports__